import {ThemeColorTextPath} from 'platform/foundation';
import {match} from 'ts-pattern';

import {always} from 'ramda';

export const getMatchTextColor = (matchType: string | undefined): ThemeColorTextPath =>
  match<string | undefined, ThemeColorTextPath>(matchType)
    .with('FULL', always('success'))
    .with('PARTIAL', always('warning'))
    .otherwise(always('primary'));
